import script from "./home.vue?vue&type=script&lang=tsx&name=home-index&setup=true"
export * from "./home.vue?vue&type=script&lang=tsx&name=home-index&setup=true"

import "./home.vue?vue&type=style&index=0&id=136c1014&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-136c1014"]])

export default __exports__